import { render, staticRenderFns } from "./DeleteModal.vue?vue&type=template&id=4d5a163f&scoped=true&"
import script from "./DeleteModal.vue?vue&type=script&lang=js&"
export * from "./DeleteModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteModal.vue?vue&type=style&index=0&id=4d5a163f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5a163f",
  null
  
)

export default component.exports